import React, { useState, useEffect } from "react";

import { Row, Col, Button } from "react-bootstrap";
import "./SessionMain.css";
import "./DownloadButton.css";
import  DownloadPdf from "./DownloadPdf.js";

import  CounterDetails from "./CounterDetails.js";
import SessionMain2OutputTable from "./SessionMain2OutputTable.js";
import InformationTabContainer from "./InformationTabContainer";
import  "./LargeSpinner.css";
import convertMSE from "../Components/Utils/convertMSE";
import aws_exports from "../aws-exports";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip
} from 'recharts';
import Amplify, { API } from "aws-amplify";


Amplify.configure(aws_exports, {});



 var mseFetchingIndex = 0;

 var mseDetailData = [];


  export default function SessionMain2(props) {

 

  const [tableData, setTableData] = useState([]);

  const [loadingMse, setLoadingMse] = useState(false);
  const [loaded, setLoaded] = useState(false);  
  const [sess, setSess] = useState ({})
  const [sett, setSett] = useState ({})
  const [outputs, setOutputs] = useState ([])
  const [counterLoad, setCounterLoasd] = useState ([])
  const [counterNumberMap, setCounterNumberMap] = useState ([])
  const [counters, setCounters] = useState([])
  const [counterID, setCounterID] = useState ("")
  const [counterOverload, setCounterOverload] = useState("")


/*
  async function downloadPDF() {
    try {
      
      let thePath = '4423/202503281413_go20Combined.pdf';
        const response = await fetch ('https://i84r4clg2d.execute-api.eu-west-1.amazonaws.com/dev/counts/getFile/Signed?PathPdf='+thePath);
        const data = await response.json();
console.log ("eeeeeeeeeeeeeeeee   "+data)
        const link = document.createElement('a');
        link.href = data.url;
        link.download = 'your-file.pdf';  // Suggest filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error('Error downloading PDF:', error);
    }
}
  */

/*
//const fetchWithAPI = () =>{
async function downloadPDF() {
  let thePath = '4423/202503281413_go20Combined.pdf';

let apiName = "vakicloudRdsAPI";
let path = "/getFile/Signed";

console.log ("props path:  "+JSON.stringify (props.Path))
let myInit = {
  // OPTIONAL
  headers: {}, // OPTIONAL
  response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
  queryStringParameters: {
    // OPTIONAL
    PathPdf: thePath
  }
};





API.get(apiName, path, myInit).then(response => {
 
          const link = document.createElement('a');
          link.href = response.urlPdf;
          link.download = 'your-file.pdf';  // Suggest filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

}).catch (err => {console.log ("Error fetching signed: "+err)});
  }

*/




function downloadCounterPDF (){

  let pdfPath = props.s3Path.replace (".MAIN2", "Counter.PDF")
  return  DownloadPdf (pdfPath)
}


function downloadStoredPDF (){

   let pdfPath = props.s3Path.replace (".MAIN2", "Stored.PDF")
   return  DownloadPdf (pdfPath)
 }


 function downloadFarmPDF (){

   let pdfPath = props.s3Path.replace (".MAIN2", "Farm.PDF")
   return  DownloadPdf (pdfPath)
 }


 function downloadCombinedPDF (){

  let pdfPath = props.s3Path.replace (".MAIN2", "Combined.PDF")
  try {
    return  DownloadPdf (pdfPath)
  } catch (error) {
     console.log (error) 
  }

}


 
  useEffect(() => {






    let s = props.Data.Session;



    let cntCap = "";


    if( !s.CounterCapasityLoad){
      let o0 = props.Data.Output0;
      if (o0 && o0.CounterCapasityLoad)
        cntCap = o0.CounterCapasityLoad.split(",");


    }else{
      cntCap = s.CounterCapasityLoad.split(",");
    }
    
    let len = cntCap.length;
    let strOverload = "";
    if (len == 0){
      strOverload = "No load data"
      len = 0;
    }
  
 

    let histo = [];
    
    let totsec = 0;
    let oversec = 0;

    let r = 0;
    for (let j=0; j<len; j++){
      r += 10;
      let str = (r-10)+"-"+r

      let c=parseInt (cntCap[j])
      totsec+=c;
      if (r>100)
        oversec += c;
     // Math.round(10000*cntCapNum[j]/sum)/100
      histo.push   ({range: str,   count: c });
      
    }

    if (totsec != 0) {

    let percent = Math.round(1000*oversec/totsec);
    percent /= 10;



    strOverload = "Overload: "+formatSeconds(oversec)+" ("+percent+"%)"

    s.CounterCapasityLoad = histo;
    }
    let cpuLoad = [];
    if (s.CPULoad == "")
       len = 0;
    else{
       cpuLoad = s.CPULoad.split (",");
       len = cpuLoad.length;
    }
        
    histo = [];
    r = 0;
    for (let j=0; j<len; j++){
      r += 10;
      let str = (r-10)+"-"+r
      let c=parseInt (cpuLoad[j])
     // Math.round(10000*cntCapNum[j]/sum)/100
      histo.push   ({range: str,   count: c });
       }
    
       s.CPULoad = histo;
      
       let numOuts = parseInt (props.Data.Settings.OutputCounts)

       let o = [];

       for (let i = 0; i<numOuts; i++){
          let strIdx = "Output"+i
          o.push (props.Data[strIdx])
       }

       let numCounters=0;
       let counterNumbers = []
       //Count the counters and get their numbers:
       let cntarr = []
       let cntr = props.Data["Counter0"];
       if (!!cntr){
          while (!!cntr){
            cntarr.push(cntr)
            counterNumbers.push (cntr.CounterNumber);
            numCounters++;
            let str = "Counter"+numCounters;
            cntr = props.Data[str];

          }
      }

     

      let strId = props.s3Path.substring (0,   props.s3Path.indexOf ("/") );

      setCounterID (strId);
      setCounters (cntarr)
setCounterOverload(strOverload);
   setCounterNumberMap(counterNumbers)
      
    setOutputs (o);   

    setSett (props.Data.Settings)   

    setSess(s)
    setLoaded (true)

   /* 
    let d = props.Data;
    let numOutputs  = d.NrCountingUnits;


    let cu = [];
 




    let sessNameLen = d.SessionDescription.length;
    sessNameLen += 8+2;   //Add Length of DateStamp and the 2x'_'
    let numUnits = d.NrCountingUnits;

    for (let i=0; i<numUnits; i++){


        d.CountingUnits[i].NetName = d.CountingUnits[i].FileName.substring(sessNameLen,  d.CountingUnits[i].FileName.toUpperCase().indexOf(".MSE") );

       
        cu.push({
            NetName : d.CountingUnits[i].NetName,
            Counter_type : d.CountingUnits[i].Counter_type,
            Count : d.CountingUnits[i].Count,
            Percent_Count : d.CountingUnits[i].Percent_Count,
            Biomass : d.CountingUnits[i].Biomass,
            Percent_Biomass : d.CountingUnits[i].Percent_Biomass,
            Average_weight : d.CountingUnits[i].Average_weight,

        key: i+1
  
        });
   
   
    }
  




    mseFetchingIndex = 0;

    setTableData (cu);    
  
    setLoadingMse(false);
    setMseLoaded (false);
    

*/


  }, [props.Data]);







  function formatSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, '0');
    const minutes = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, '0');
    const seconds = Math.floor(totalSeconds % 60)
      .toString()
      .padStart(2, '0');
  
    return `${hours}:${minutes}:${seconds}`;
  }




  let CounterHistogram = (
    <div style={{ width: 300}}>
      <h4 style={{ marginLeft: 10 }}>Counter load   </h4>
      <BarChart 
        width = {300}
        height = {120}
        data={sess.CounterCapasityLoad}  
        margin={{ top: 0, right: 30, left:-50, bottom: 5 }}
        >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="range" tick={false}/>
        <YAxis tick={false} />
        <Tooltip 
         labelFormatter={(value) => `Load: ${value}%`}
          formatter={(value) => [formatSeconds(value), 'Duration']}
        />
        <Bar dataKey="count" fill="#007bff" />
      </BarChart>
      <div style={{ marginTop: '-30px', marginLeft: "10px", fontSize: '14px', color: 'gray' }}>
    {counterOverload}
  </div>

    </div>
  );




  let CpuHistogram = (
    <div style={{ width: 300 }}>
      <h4 style={{ marginLeft: 10 }}>CPU load   </h4>
    <BarChart 
    width = {300}
    height = {120}
      data={sess.CPULoad}  margin={{ top: 0, right: 30, left:-50, bottom: 5 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="range" tick={false}/>
      <YAxis tick={false} />
      <Tooltip 
       labelFormatter={(value) => `Load: ${value}%`}
        formatter={(value) => [formatSeconds(value), 'Duration']}
      />
      <Bar dataKey="count" fill="#007bff" />
    </BarChart>
  </div>
);




const oaDateToISOString = (oaDateStr) => {

    let oaDate = parseFloat  (oaDateStr.replace (",", "."))
    const msPerDay = 24 * 60 * 60 * 1000;
    const baseDate = new Date(Date.UTC(1899, 11, 30)); // Dec 30, 1899
    const jsDate = new Date(baseDate.getTime() + oaDate * msPerDay);
  
    const pad = (n) => n.toString().padStart(2, '0');
  
    return `${jsDate.getFullYear()}-${pad(jsDate.getMonth() + 1)}-${pad(jsDate.getDate())} ` +
           `${pad(jsDate.getHours())}:${pad(jsDate.getMinutes())}:${pad(jsDate.getSeconds())}`;
  }


  const formatTimeSpan = (oaStartStr, oaEndStr) => {
    if (!oaStartStr || !oaEndStr)
      return "";


    let oaStart = parseFloat  (oaStartStr.replace (",", "."))
    let oaEnd = parseFloat  (oaEndStr.replace (",", "."))
    const msPerDay = 24 * 60 * 60 * 1000;
    const diffMs = (oaEnd - oaStart) * msPerDay;
  
    if (diffMs < 0) return "Invalid (negative timespan)";
  
    const totalSeconds = Math.floor(diffMs / 1000);
  
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    const pad = (n) => n.toString().padStart(2, '0');
  
    let result = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    if (days > 0) {
      result = `${days}d ${result}`;
    }
  
    return result;
  }















//const SessionMain = props => (


const MseDetailsNotify = (idx) => {


    let len = props.Data.NrCountingUnits;
    let tmp = [];
    for (let i = 0; i<len; i++){
        tmp.push({...tableData[i], key:i})
    }
    tmp [idx]. activeButton = false;
    setTableData(tmp);

};


const getMseFile = async (s3Path, urls) => {




//    s3Path = s3Path.replace("999999/", "3153/")
 
    //  await downloadPDF()




    let apiName = "vakicloudRdsAPI";
    let path =  "/getFile"; 
    let myInit = {
      // OPTIONAL
      headers: {}, // OPTIONAL
      response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {
        // OPTIONAL
          S3Path: s3Path
      }
    };




    API.get(apiName, path, myInit).then(resp => {
    //  let str  =  resp.success.toUpperCase();
   

      let data = null;
        if (mseFetchingIndex==0)
            mseDetailData = [];
        data = convertMSE(resp.success);



        mseDetailData.push({
          mainData:null,
          informationRowData: data,
          newDataLoaded: true,
          newDataLoading: false,
          blcFileURL: props.Data.CountingUnits[mseFetchingIndex].blcFileUrl,
          cntFileURL: props.Data.CountingUnits[mseFetchingIndex].cntFile,
          mseFileURL: props.Data.CountingUnits[mseFetchingIndex].mseFileUrl,
          pdfFileURL: null,
          mseS3Path: props.Data.CountingUnits[mseFetchingIndex].mseS3Path,
          pdfFilePath: null,
          blcFilePath: props.Data.CountingUnits[mseFetchingIndex].blcFilePath,
          cntFilePath: props.Data.CountingUnits[mseFetchingIndex].cntFilePath,
          key:mseFetchingIndex
        });
       

        mseFetchingIndex++;
        if (mseFetchingIndex < props.Data.NrCountingUnits){
            setTimeout (callGetMseFile, 100, mseFetchingIndex);
        }else{
            setLoadingMse(false);
            setLoaded (true);
        }


        



    }).  catch (err =>{
      console.log ("Error when fetching msefile ("+mseFetchingIndex+") : "+err)

    });
   
  };


const  callGetMseFile = async (idx) =>
{

    getMseFile (props.Data.CountingUnits[idx].mseFilePath);
}  





const handleShowMseClick = () => {
  
   
}


const scrollToBottom = () => {
    let fakeD = document.getElementById("fakeDiv");
    fakeD.scrollIntoView({ behavior: "smooth" });
  };


var MseArea = "";

if (loadingMse){
    MseArea = <div className="spinner-wrap">  <div className="loader"></div> </div>

} else if (!loaded){
    MseArea=     <Button variant="outline-secondary" type="Button" block name = "getmse"  onClick = {handleShowMseClick}  >
    Fetch units details
    </Button>;
    
}else {
    MseArea = [];
    let len = mseDetailData.length;

    for (let i=0; i<len; i++){



        MseArea.push(
     <div className = "unit-wrap">       
        <h4> {"Unit: "+props.Data.CountingUnits[i].NetName }</h4>
    <InformationTabContainer

    key={i}    
    data= {mseDetailData[i].informationRowData}
    blcFileURL = {props.Data.CountingUnits[i].blcFileUrl}
//cntFileURL: props.Data.CountingUnits[mseFetchingIndex].cntFile,
    mseFileURL = {props.Data.CountingUnits[i].mseFileUrl}
    pdfFileURL={null}
    mseS3Path = {props.Data.CountingUnits[i].mseS3Path}
    pdfFilePath={null}
    blcFilePath = {props.Data.CountingUnits[i].blcFilePath}
    cntFilePath= {props.Data.CountingUnits[i].cntFilePath}
    scrollToBottom= {null} //{scrollToBottom}
        />
        </div>
        );

    }
    //display details
}

let CntrDetails = [];
if (loaded){
  let numC = counters.length;

  for (let i = 0; i< numC; i++){
    let spell = true;
    let fname = counters[i].Filename;
    if (!fname){
      fname = counters[i].FileName;
      spell = false

    }
    if (spell){
     if (counters[i].Filename.startsWith("c:\\reports\\")){
        counters[i].Filename = counters[i].Filename.substring(11);
   
      }

      CntrDetails. push(
        <CounterDetails  key={i} Path = {counterID+"/"+counters[i].Filename }  CounterName = {"Counter "+counters[i].CounterNumber}    />
      )
    }else{
     if (counters[i].FileName.startsWith("c:\\reports\\")){
        counters[i].FileName = counters[i].FileName.substring(11);
   
      }

      CntrDetails. push(
        <CounterDetails  key={i} Path = {counterID+"/"+counters[i].FileName }  CounterName = {"Counter "+counters[i].CounterNumber}    />
      )


    }
  }
}





let pdfFileUrl = props.Data.pdfFile; //.replace("999999", "3153")


const fixWidth ={
  width:"130px",
  marginLeft: "25px"

}

let pdfCounter = props.Data.Session.CounterReportCreated;
let pdfFarm = props.Data.Session.FarmReportCreated;
let pdfCombined = props.Data.Session.CombinedReportCreated;
let pdfStored = props.Data.Session.StoredReportCreated;



//If entry is missing - all buttons showed
let showAll = (pdfCounter === undefined)

let combinedButton = "";
let counterButton = "";
let farmButton = "";
let storedButton = ""



if (showAll || pdfCombined == "1")
    combinedButton = <button style={fixWidth}  className="buttonStyle"  onClick={downloadCombinedPDF}><i className="fa fa-download" aria-hidden="true"></i> Combined</button>;
if (showAll || pdfCounter == "1")
  counterButton = <button style={fixWidth} className="buttonStyle"  onClick={downloadCounterPDF} ><i className="fa fa-download" aria-hidden="true"></i> Counter</button>

if (showAll || pdfFarm == "1")
  farmButton = <button style={fixWidth}  className="buttonStyle"  onClick={downloadFarmPDF}><i className="fa fa-download" aria-hidden="true"></i> Farm</button>

if (showAll || pdfStored == "1")
  storedButton = <button style={fixWidth}  className="buttonStyle"  onClick={downloadStoredPDF}><i className="fa fa-download" aria-hidden="true"></i> Stored</button>




//  <SessionMainTable TableData={tableData}    MseDetailsNotify = {MseDetailsNotify} />
    return(
  <div>
    <Row className="Information-tab">
      <Col sm>
        <div>
          <h4>
            <span> Total Counted:</span>{" "}
            <span><b>{sess.TotalFishNumber}</b></span>
          </h4>
        </div>
      </Col>
    </Row>
    <hr />
    <Row className="Information-tab">
      <Col xl={2} sm={6}>
        <div>
          <h4 className="inl">
            <span className="inl-front"> Session:</span>
            <span className="inl-back">{sess.SessionDescription}</span>
          </h4>


 
        </div>
      </Col>
      <Col xl={2} sm={6}>
        <div>
        <h4 className="inl">
            <span className="inl-front"> Avg.Weight: </span>
            <span className="inl-back">{loaded && Math.round(parseFloat (sess.AverageWeight.replace(",",".")))}g</span>
          </h4>
        </div>
      </Col>

      <Col xl={2} sm={6}>
      <h4 className="inl">
            <span className="inl-front"> Tot.Biomass: </span>
            <span className="inl-back">{loaded && Math.round(parseFloat (sess.TotalBiomass.replace(",",".")/1000))}kg</span>
          </h4>
      </Col>
      <Col xl={2} sm={6}>
      <h4 className="inl">
            <span className="inl-front"> Operator:</span>
            <span className="inl-back">{sess.operator}</span>
          </h4>
      </Col>
      <Col xl={2} sm={6}>
      <h4 className="inl">
            <span className="inl-front"> Duration:</span>
            {loaded&&formatTimeSpan (sess.StartTime, sess.EndTime) }
            </h4>
      </Col>


    </Row>

  <Row>
  <Col xl={2} sm={6}  >

  <h4 style={{ marginLeft: 10 }}>Download PDF report:  </h4>

    <div className = "buttonContainerStyle">
      {counterButton}
      {storedButton}
      {farmButton}
      {combinedButton}
    </div>
      </Col>

    <Col xl={3} sm={8}>
       {loaded&&CounterHistogram}
   </Col>

<Col xl={3} sm={8}>
    {loaded&&CpuHistogram}

    </Col>

    </Row>



{loaded && <SessionMain2OutputTable   Data = {outputs}  CountersMap = {counterNumberMap}  />}


{CntrDetails}

    <div id="mse-wrap">
        
        {MseArea}
    </div>
  </div>
);
};


/*
    <Col xl={2} sm={6}  className="dl-buttons">
    <a id="PDF-dl" href={pdfFileUrl}> <i className="fa fa-download" aria-hidden="true"></i> Download PDF Report  </a>


    <button onClick={downloadPDF}   >Download</button>
      </Col>

*/